import {
  BuyingToolItemProps,
  FooterBuyingTools,
} from '@/app/components/layouts/footer/buying-tool';
import {
  FooterContact,
  FooterContactProps,
} from '@/app/components/layouts/footer/contact';
import {
  FooterNav,
  FooterNavColumn,
} from '@/app/components/layouts/footer/nav';
import { FOOTER_DATA_TEST } from '@/app/components/layouts/footer/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface FooterProps {
  buyingTools: BuyingToolItemProps[];
  contact: FooterContactProps;
  nav: FooterNavColumn[];
}

export const Footer = ({ buyingTools, contact, nav }: FooterProps) => {
  return (
    <footer
      {...createDataAttributes({
        test: FOOTER_DATA_TEST.footer,
      })}
      className="where-span:inline-block"
      data-myi-hide
    >
      <FooterBuyingTools items={buyingTools} />
      <FooterContact {...contact} />
      <FooterNav items={nav} />
    </footer>
  );
};
